import { isTrueOrZero } from 'common/utils/numbers'

export const objectToQueryString = (object: { [key: string]: unknown }) =>
  Object.entries(object).reduce((acc, [key, value]) => {
    if (isTrueOrZero(value)) {
      return `${acc}${acc ? '&' : '?'}${key}=${value}`
    }
    return acc
  }, '')
